export const sourcesOptions = {
  energy: [
    { key: "energia_total", text: "Energía total", value: "Energía total" },
    { key: "electricidad_industrial", text: "Electricidad de uso industrial (En3)", value: "Electricidad de uso industrial" },
    { key: "electricidad_domestica", text: "Electricidad de uso doméstico (En2)", value: "Electricidad de uso doméstico" },
    { key: "energia_electrica", text: "Energía eléctrica (En1)", value: "Energía eléctrica" },
    { key: "energia_renovable", text: "Energía renovable (En9)", value: "Energía renovable" },
    { key: "diesel", text: "Diésel (En29)", value: "Diésel" },
    { key: "vapor", text: "Vapor (En51)", value: "Vapor" },
    { key: "co2", text: "Emisiones de CO2", value: "Emisiones de CO2" },
    { key: "gas_natural", text: "Gas Natural (En13)", value: "Gas Natural" },
    { key: "glp", text: "GLP (gas licuado de petróleo) (En18)", value: "GLP (gas licuado de petróleo)" },
    { key: "hfo", text: "Heavy Fuel Oil (aceite combustible pesado) (En23)", value: "Heavy Fuel Oil (aceite combustible pesado)" },
    { key: "lfo", text: "Light Fuel Oil (aceite combustible) (En25)", value: "Light Fuel Oil (aceite combustible)" },
    { key: "carbon", text: "Carbón (En27)", value: "Carbón" },
    { key: "gasolina", text: "Gasolina para vehículos internos (autoelevadores) (En39)", value: "Gasolina para vehículos internos (autoelevadores)" },
    { key: "biomasa", text: "Biomasa (En49)", value: "Biomasa" },
  ],
  fuels: [
    { key: "gas_natural", text: "Gas Natural (Veh1)", value: "Gas Natural" },
    { key: "glp", text: "GLP (gas licuado de petróleo) (Veh3)", value: "GLP (gas licuado de petróleo)" },
    { key: "hfo", text: "Heavy Fuel Oil (aceite combustible pesado)", value: "Heavy Fuel Oil (aceite combustible pesado)" },
    { key: "lfo", text: "Light Fuel Oil (aceite combustible)", value: "Light Fuel Oil (aceite combustible)" },
    { key: "diesel", text: "Diésel (Veh5)", value: "Diésel" },
    { key: "gasolina", text: "Gasolina para vehículos internos (autoelevadores) (Veh9)", value: "Gasolina para vehículos internos (autoelevadores)" },
    { key: "biodiesel", text: "Biodiésel (Veh7)", value: "Biodiésel" },
    { key: "biogas", text: "Biogás", value: "Biogás" },
    { key: "etanol", text: "Etanol (Veh11)", value: "Etanol" },
    { key: "elect_vehiculos", text: "Electricidad para vehículos (Veh13)", value: "Electricidad para vehículos" },
    { key: "km_avion", text: "Kilómetros de viajes de avión", value: "Kilómetros de viajes de avión" },
  ],
  water: [
    { key: "agua_total", text: "Agua total", value: "Agua total" },
    { key: "agua_industrial", text: "Agua de uso industrial (Agu2)", value: "Agua de uso industrial" },
    { key: "agua_domestica", text: "Agua de uso doméstico (Agu1)", value: "Agua de uso doméstico" },
    { key: "agua_municipal", text: "Agua de la red municipal (Agu3)", value: "Agua de la red municipal" },
    { key: "agua_lluvia", text: "Agua de lluvia (Agu13)", value: "Agua de lluvia" },
    { key: "agua_subterranea", text: "Agua subterránea (Agu9)", value: "Agua subterránea" },
    { key: "agua_superficial", text: "Agua superficial (Agu14)", value: "Agua superficial" },
    { key: "agua_condensada", text: "Agua condensada de vapor (Agu18)", value: "Agua condensada de vapor" },
  ],
  waste: [
    { key: "no_peligrosos", text: "Residuos no peligrosos", value: "Residuos no peligrosos" },
    { key: "peligrosos", text: "Residuos peligrosos", value: "Residuos peligrosos" },
    { key: "papel_carton", text: "Papel y cartón (re1)", value: "Papel y cartón" },
    { key: "plastico", text: "Plástico (re2)", value: "Plástico" },
    { key: "tela", text: "Tela o scrap, retazos (re3)", value: "Tela o scrap, retazos" },
    { key: "metal", text: "Metal (agujas o virutas no contaminadas) (re4)", value: "Metal (agujas o virutas no contaminadas)" },
    { key: "madera", text: "Madera (re5)", value: "Madera" },
    { key: "otros", text: "Otros no peligrosos (re13)", value: "Otros no peligrosos" },
    { key: "comida", text: "Comida (re6)", value: "Comida" },
    { key: "vidrio", text: "Vidrio (re8)", value: "Vidrio" },
    { key: "cuero", text: "Cuero (re9)", value: "Cuero" },
    { key: "espuma", text: "Espuma (EVA) (re10)", value: "Espuma (EVA)" },
    { key: "electronicos", text: "Residuos electrónicos (Re14)", value: "Residuos electrónicos" },
    { key: "latas_no_peligrosas", text: "Latas o recipientes vacíos (no peligroso) (re11)", value: "Latas o recipientes vacíos (no peligroso)" },
    { key: "latas_peligrosas", text: "Latas o recipientes vacíos (peligroso)", value: "Latas o recipientes vacíos (peligroso)" },
    { key: "baterias", text: "Baterías (Re17)", value: "Baterías" },
    { key: "tubos", text: "Tubos fluorescentes (Re18)", value: "Tubos fluorescentes" },
    { key: "aceite_cocina", text: "Aceite de cocina (Re19)", value: "Aceite de cocina" },
    { key: "aceite_mantenimiento", text: "Aceite de mantenimiento (Re20)", value: "Aceite de mantenimiento" },
    { key: "lubricantes", text: "Lubricantes (Re21)", value: "Lubricantes" },
    { key: "pinturas", text: "Restos de pinturas (Re22)", value: "Restos de pinturas" },
    { key: "cenizas", text: "Cenizas de carbón (Re23)", value: "Cenizas de carbón" },
    { key: "caucho", text: "Caucho (rubber) (re12)", value: "Caucho (rubber)" },
  ],
  effluent: [
    { key: "industrial", text: "Efluente industrial (Efl2)", value: "Efluente industrial" },
    { key: "domestico", text: "Efluente doméstico (Efl1)", value: "Efluente doméstico" },
    { key: "total", text: "Efluente total (Efl3)", value: "Efluente total" },
    { key: "lodos", text: "Lodos (Efl4)", value: "Lodos" },
  ],
};
